import { CollapsedSection, DiffListItem, ProcessedDiff, ProcessedLine } from '@components/ncFileVersions/components/NCFileDiffView/types';
import { isCollapsedSection } from './utils';
import { determineLineGroupPosition } from '@components/ncFileVersions/components/NCFileDiffView/hooks/useManageDiff';

const neighborLine = (arr: (ProcessedLine | CollapsedSection)[], idx: number): ProcessedLine | undefined => {
  const item = arr[idx];
  return item && !isCollapsedSection(item) ? item : undefined;
};

export const buildPreparedListItems = (processedDiff: ProcessedDiff): DiffListItem[] => {
  const items: DiffListItem[] = [];
  const { oldLines, newLines } = processedDiff;
  const count = Math.max(oldLines.length, newLines.length);

  for (let i = 0; i < count; i++) {
    const oldItem = oldLines[i];
    const newItem = newLines[i];

    if (isCollapsedSection(oldItem)) {
      items.push({ type: 'collapsed', key: oldItem.key, section: oldItem });
      continue;
    }

    // Aligned: when oldItem is a ProcessedLine, newItem is too.
    const newLine = newItem as ProcessedLine;
    const isGroupStart = i === 0 || isCollapsedSection(oldLines[i - 1]);
    const isGroupEnd = i === count - 1 || isCollapsedSection(oldLines[i + 1]);

    items.push({
      type: 'row',
      key: oldItem.key,
      oldLine: oldItem,
      newLine: isCollapsedSection(newItem) ? null : newItem,
      isGroupStart,
      isGroupEnd,
      index: i,
      groupPositionOld: determineLineGroupPosition(oldItem, neighborLine(oldLines, i - 1), neighborLine(oldLines, i + 1)),
      groupPositionNew: determineLineGroupPosition(newLine, neighborLine(newLines, i - 1), neighborLine(newLines, i + 1)),
    });
  }

  return items;
};
